import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './style.css';

// Render the React app
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
